
// //@ts-ignore
// const ActPromise = {
// //@ts-ignore
//   resolve: (val) => val ? { then: fn => (fn(val), ActPromise.resolve(val)), catch: fn => {} } : { catch: fn => fn(val) },
// //@ts-ignore
//   reject: (val) => ({ catch: fn => fn(val) }),
// } as Promise<boolean>;

export interface IResolve<T> {
	then: (fn: Function) => (IResolve<T>|IReject<T>);
	// catch: (fn: Function) => (IResolve<T>|IReject<T>);
	catch: (fn: Function) => void;
	finally: (fn: () => void) => void;
};

export interface IReject<T> {
	catch: (fn: Function) => (IResolve<T>|IReject<T>);
	finally: (fn: () => void) => void;
}

interface IActPromise<T> {
	resolve: (val: T) => IResolve<T>;
	reject: (val: T) => IReject<T>;
};

export const ActPromiseBoolean: IActPromise<boolean> = {
	resolve: (val: boolean) => ({
		then: (fn: Function) => {
			try {
				const res = fn(val);
				return ActPromiseBoolean.resolve(res);
			} catch (err) {
				return ActPromiseBoolean.reject(false);
			}
		},
		catch: (fn: Function) => {},
		finally: (fn: () => void) => fn()
	}),
	reject: (val: boolean) => ({
		catch: (fn: Function) => {
			try {
				const res = fn(val);
				return ActPromiseBoolean.resolve(res);
			} catch (err) {
				return ActPromiseBoolean.reject(false);
			}
		},
		finally: (fn: () => void) => fn()
	}),
}/* as Promise<T>;*/